import { Button }         from '@/components/ui/button';
import { Dispatch }       from 'react';
import { Field }          from '@/components/ui/field';
import { Input }          from '@chakra-ui/react';
import { PasswordInput }  from '@/components/ui/password-input';
import { SetStateAction } from 'react';
import { Stack }          from '@chakra-ui/react';
import { Text }           from '@chakra-ui/react';
import authStore          from '@/stores/authStore';
import { toaster }        from '@/components/ui/toaster';
import { useForm }        from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useTranslations    from '@/hooks/useTranslations';

interface IEmailFormProps {
	setIsOpen: Dispatch<SetStateAction<boolean>>;
	onChangeEmailSuccess: (newEmail: string) => void;
}

interface FormValues {
	newEmail: string;
	confirmNewEmail: string;
	password: string;
}

const EmailForm = (props: IEmailFormProps) => {
	const { setIsOpen, onChangeEmailSuccess } = props;
	const { t } =  useTranslation();
	const { getNavigationTranslation } = useTranslations();
	const currentUser = authStore.currentUser;

	const {
		formState: { errors, isSubmitting },
		getValues,
        handleSubmit,
        register,
    } = useForm<FormValues>()
	
	const onSubmit = handleSubmit(async (data) => {
		try {
			await currentUser.patch({
				newEmail: data.newEmail,
				plainPassword: data.password,
				confirmEmailUrl: location.origin + getNavigationTranslation('confirmationEmail', 'path'),
			});
			onChangeEmailSuccess(data.newEmail);
			setIsOpen(false);

		} catch (error) {
			toaster.create({
                title: t('pages.security.emailBox.modals.forms.messages.errors.error'),
                type: 'error'
            })
			console.log(error);
		}
	})

	return (
		<form onSubmit={onSubmit}>
			<Stack gap="20px" marginTop="20px">
				<Field
					label={
						<Text 
							className="poppins-semibold" 
							fontSize="14px" 
							fontWeight="bold"
						>
							{t('pages.security.emailBox.modals.forms.new')}
						</Text>
					}
					invalid={!!errors.newEmail}
					required
				>
					<Input
						defaultValue={currentUser.email}
						placeholder={t('pages.security.emailBox.modals.forms.new')}
						{...register('newEmail', { required: true })}
					/>
				</Field>
				<Field
					label={
						<Text 
							className="poppins-semibold" 
							fontSize="14px" 
							fontWeight="bold"
						>
							{t('pages.security.emailBox.modals.forms.confirm')}
						</Text>
					}
					invalid={!!errors.confirmNewEmail}
					required
				>
					<Input
						placeholder={t('pages.security.emailBox.modals.forms.confirm')}
						{...register('confirmNewEmail', {
							pattern: {
								value: /\S+@\S+\.\S+/,
								message: t('pages.security.emailBox.modals.forms.messages.errors.pattern'),
							},
							validate: value => {
								const { newEmail } = getValues();
								return newEmail === value;
							},
						})}
					/>
					{errors.confirmNewEmail?.type === 'pattern' && <Text color="red">{t('pages.security.emailBox.modals.forms.messages.errors.pattern')}</Text>}
					{errors.confirmNewEmail?.type === 'validate' && <Text color="red">{t('pages.security.emailBox.modals.forms.messages.errors.match')}</Text>}
				</Field>
				<Field
					label={
						<Text 
							className="poppins-semibold" 
							fontSize="14px" 
							fontWeight="bold"
						>
							{t('pages.security.emailBox.modals.forms.password')}
						</Text>
					}
					invalid={!!errors.password}
					required
				>
					<PasswordInput
                        placeholder={t('pages.security.emailBox.modals.forms.password')}
                        {...register("password")}
                    />
				</Field>

				<Button 
					variant="solid" 
					type="submit" 
					width="100%"
					marginTop="30px"
					loading={isSubmitting}
				>
					{t('pages.security.emailBox.modals.forms.actions.save')}
				</Button>
			</Stack>
		</form>
	);
};

export default EmailForm;